export default {
  meta: {
    title: '踩点分析报告',
    url: '/footprinting/review', // 埋点用，记录所属模块
    // eventId: 'c9838a44-341c-4ebe-be7e-43a7a6838410'
  },
};
